import React, { useEffect } from 'react'
import { Paper } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import {
  getReportDataThunk,
  getReportHeadersThunk,
  setStatusData,
  setStatusHeaders,
  setReportData,
  setHeaders,
} from '../../redux/slices/Report/reportSlice'
import GenerateReportComponent from './GenerateReportComponent'
import LoaderContainer from '../../components/Loader/LoaderComponent'

export default function GenerateReportContainer() {
  const dispatch = useDispatch()
  const TOKEN = `Bearer ${window.localStorage.getItem('arbolQR_Token')}`
  const _state = useSelector(state => state.drawerLeft)
  const headers = useSelector(state => state.report.headers)
  const loadingReportHeaders = useSelector(state => state.report.statusHeaders)

  const reportData = useSelector(state => state.report.reportData)
  const loadingReportData = useSelector(state => state.report.statusData)

  const getHeaders = async token => {
    void dispatch(getReportDataThunk(token))
  }

  const getData = async token => {
    void dispatch(getReportHeadersThunk(token))
  }

  window.history.pushState(null, null, window.location.href)
  window.onpopstate = function (event) {
    window.history.go(1)
  }

  window.addEventListener('keydown', function (e) {
    if (e.key === 'U+0052' || (e.ctrlKey && e.key === 'r') || e.key === 'F5')
      e.preventDefault()
  })

  window.addEventListener('beforeunload', function (event) {
    event.preventDefault()
    event.returnValue = '¿Estás seguro de que deseas abandonar esta página?'
  })

  useEffect(() => {
    if (headers.length <= 0) getHeaders(TOKEN)
    if (reportData.length <= 0) getData(TOKEN)

    return () => {
      window.onpopstate = null
      window.removeEventListener('beforeunload', function (event) {
        event.preventDefault()
        event.returnValue = '¿Estás seguro de que deseas abandonar esta página?'
      })
      window.removeEventListener('keydown', function (e) {
        if (e.key === 'U+0052' || (e.ctrlKey && e.key === 'r') || e.key === 'F5')
          e.preventDefault()
      })
      dispatch(setStatusData(''))
      dispatch(setStatusHeaders(''))
      dispatch(setReportData([]))
      dispatch(setHeaders([]))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Paper
      sx={{
        mt: _state.drawerHeight,
        ml: _state.open ? `${_state.drawerWidth}px` : undefined,
        width: `100vw`,
      }}
      square>
      <LoaderContainer
        conditions={[
          loadingReportHeaders === 'loading',
          loadingReportData === 'loading',
        ]}>
        <GenerateReportComponent headers={headers} reportData={reportData} />
      </LoaderContainer>
    </Paper>
  )
}
